import { flatMap, sortBy, uniq } from 'lodash'
import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { getConfiguration } from '../../../helpers/configuration'
import {
  getCalendarTypeName,
  getCourseStudentStudyPackageNumber,
  getSemester1BlockModelCalendarTypes,
  getSemester2BlockModelCalendarTypes,
  getSummerBlockModelCalendarTypes,
  getSummerBlockModelClosingCalendarTypes,
  getUnitsByCalendarTypes,
  getWinterBlockModelCalendarTypes,
} from '../../../helpers/enrolment'
import {
  getDropDateUnitText,
  unitDropDatePassed
} from '../../../helpers/unitDropDateHelper'
import { getReferences, getStudyPeriodsCodesDescription, searchUnits, getAttendanceModeCodesDetails, getAttendanceModeDescription  } from '../../../services/vu'
import AddUnitHolder from '../AddUnitHolder'
import Loading from '../Loading'
import { AddUnit } from '../Unit'
import { CustomModal } from './Modal'
import { Link } from '@mui/icons-material'

class SuggestedUnitsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      locations: [],
      units: [],
      studyPeriods: [],
      loading: true,
      showDropDatePassedConfirmationModal: false,
      dropDateDisabled: false,
      unitToAdd: null,
      successfulRedirect: false,
      isOpen: false
    }
  }

  componentDidMount() {
    Promise.all([getReferences(), getStudyPeriodsCodesDescription(),  getAttendanceModeCodesDetails()]).then(([{ locationList = [] }, studyPeriods, attendanceModeList]) => {
      this.setState({
        locations: locationList,
        studyPeriods: studyPeriods.referenceCodes,
        attendanceModeList : attendanceModeList.referenceCodes,
        loading: false
      })
    })
   
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.props.isOpen && prevProps.isOpen) {
      this.setState({
        isOpen: false
      })
    }
    if (this.props.isOpen && this.props.units && !prevProps.isOpen) {
      this.setState({
        loading: prevProps.calendarType !== this.props.calendarType || prevProps.year !== this.props.year,
        isOpen: true
      })
    } else if (this.state.isOpen && this.props.units && !prevState.loading && this.state.loading ) {
        this.loadUnit()
    }
  }

  loadUnit = () => {
    if (!this.props.isOpen) {
      return {}
    }

    const unitUnitCodes = uniq(this.props.units
      .map(unit => unit.unitCode))



    const promises = unitUnitCodes.map(unitCd =>
      searchUnits(getCourseStudentStudyPackageNumber(), this.props.year, this.props.calendarType, unitCd)
    )

    Promise.all(promises)
      .then((searchResults = []) =>
        flatMap(searchResults, (searchResult = []) => searchResult)
      )
      .then((searchResults = []) => {

        this.setState({
          loading: false,
          units: searchResults
        })
      })
  }

  // getCampusByUnitLocationCd = unitLocationCd => {
  //   const location = this.state.locations.find(
  //     location => location.locationCd === unitLocationCd
  //   )
  //   if (location) {
  //     return location.description
  //   }
  //   return unitLocationCd
  // }

  // hasPrereqs = (coReq = [], preReq = []) => {
  //   return (
  //     coReq.some(({ unitCode }) => unitCode !== '') ||
  //     preReq.some(({ unitCode }) => unitCode !== '')
  //   )
  // }

  getSortedUnits = (areAllZero = false) => {
    let units = areAllZero ? this.state.units.filter(unit => unit.unitAvailabilityQuotaRemaining !== 0) : this.state.units;

    return sortBy(units, 'unitCd')
  }
  

  getEnrolledUnits = () => {
    return this.props.enrolledUnits
  }

  handleCloseModal = () => {
    this.setState({
      isOpen: false
    })
    this.props.handleCloseModal()
  }

  handleError = (message) => {
    this.setState({
      isOpen: false
    })
    this.props.handleError(message)
  }

  renderSuggestions = () => {
    if (this.state.loading) {
      return <Loading />
    }

    if (!this.state.isOpen) {
      return null
    }

    if (this.getSortedUnits().length > 0) {
      return this.getSortedUnits().map((unit, index) => {

        const unitCode = unit.unitCode
        const unitShortTitle = unit.unitShortTitle
        const unitCreditPoints = unit.unitCreditPoints
        const unitAvailabilityLocationDescription = unit.unitAvailabilityLocationDescription
        const unitAvailabilityAttendanceModeDescription = getAttendanceModeDescription(this.state.attendanceModeList,unit.unitAvailabilityAttendanceModeCode)
        const fullUnit = unit.unitAvailabilityMaxQuota > 0 && unit.unitAvailabilityQuotaRemaining !== null && unit.unitAvailabilityQuotaRemaining <= 0
        const unitRequisiteFlag = unit.unitRequisiteFlag

        return (
          <div className="col-xs-6 col-sm-3" key={index}>
            <div className="block-container">
              <AddUnit
                  code={unitCode}
                  name={unitShortTitle}
                  creditPoints={`${unitCreditPoints || 0} points`}
                  attendanceMode={unitAvailabilityAttendanceModeDescription}
                  campus={unitAvailabilityLocationDescription}
                  core={false}
                  onAdd={() => this.addUnit(unit)}
                  disabled={fullUnit}
                  hasRequisite={unitRequisiteFlag}
              />
              {(unit.unitAvailabilityQuotaRemaining === null || unit.unitAvailabilityQuotaRemaining > 0) &&
                getDropDateUnitText(unit)
              }
              <div className="txt-quota">
                {unit.unitAvailabilityQuotaRemaining !== null && unit.unitAvailabilityQuotaRemaining >= 0 && unit.unitAvailabilityMaxQuota !== 0 ? (
                  <span>{unit.unitAvailabilityQuotaRemaining} spots remaining</span>
                ) : null}
              </div>
            </div>
          </div>
        )
      })
    } else if (!this.props.canAddBeyondFirstYear || (this.props.canAddBeyondFirstYear && !this.isFirstYearEnrolledTillGivenBlock())) {
      this.handleError('There is no unit available in this block.' + ' For assistance enrolling in a unit or to discuss unit options in this block, contact VUHQ.')
      return null
    }
  }

  //Get all active block calendars
  getAllActiveBlockCalendars = () => {
    return this.blockModelSemester(this.props.year, getSummerBlockModelCalendarTypes())
      .concat(this.blockModelSemester(this.props.year, getSemester1BlockModelCalendarTypes(), true))
      .concat(this.blockModelSemester(this.props.year, getWinterBlockModelCalendarTypes()))
      .concat(this.blockModelSemester(this.props.year, getSemester2BlockModelCalendarTypes(), true))
      .concat(this.blockModelSemester(this.props.year, getSummerBlockModelClosingCalendarTypes()))
  }

  blockModelSemester = (year, blockCalendarTypes = [], mandatory = false) => {
    const allCalendarTypes = blockCalendarTypes

    // do not take into account calendars
    // if none of the relevant calendar types associated are open.
    const activeBlockCohorts = this.props.cohorts.filter(({ cohortDtls }) => {
      return (
        cohortDtls.acadAlternateCode === year &&
        allCalendarTypes.some(calendarType => {
          return cohortDtls.calType === calendarType
        })
      )
    })
    if (activeBlockCohorts.length === 0) {
      return []
    }

    return allCalendarTypes
  }

  isFirstYearEnrolledTillGivenBlock = () => {
    const minimumAdvanceStandCreditRequired = 48
    if (
      this.props.totalAdvanceStandingCredit >= minimumAdvanceStandCreditRequired
    ) {
      return true
    }
    const allActiveBlockCalendars = this.getAllActiveBlockCalendars()
    //getting all the blocks till the block where the suggestions are asked for
    const allBlocksTillGivenBlock = allActiveBlockCalendars.slice(
      0,
      allActiveBlockCalendars.indexOf(this.props.calendarType)
    )

    if (allBlocksTillGivenBlock.length == 0) {
      return false
    }
    const enrolledUnits = this.getEnrolledUnits()

    if (enrolledUnits.length == 0) {
      return false
    }
    //get all the enrolled units for above calendar types and year
    const unitsInActiveBlock = getUnitsByCalendarTypes(
      enrolledUnits,
      allBlocksTillGivenBlock,
      this.props.year
    )
    //filter first year units that is check against the pattern
    const allUnitsInActiveBlocksInCoursePatterns = this.props.coursePatternsNoExclusions
      .filter(offering => {
        return (
          allActiveBlockCalendars.indexOf(offering.teachingCalenderType) !=
            -1 && offering.academicYear === this.props.year
        )
      })
      .map(function(offering) {
        return offering.unitCode
      })

    //credit point check for all the units
    const unitsEnrolledInGivenCoursePattern = unitsInActiveBlock.filter(
      ({ unitCd }) => {
        return allUnitsInActiveBlocksInCoursePatterns.indexOf(unitCd) != -1
      }
    )

    //credit point calculation
    const totalCreditPointsFirstYear = unitsEnrolledInGivenCoursePattern.reduce(
      function(a, b) {
        return a + b['achievableCreditPoints']
      },
      0
    )

    return (
      totalCreditPointsFirstYear + this.props.totalAdvanceStandingCredit >= 48
    )
  }

  advanceStandingCreditRemaining = () => {
    if (this.props.canAddBeyondFirstYear) {
      const allActiveBlockCalendars = this.getAllActiveBlockCalendars()

      const enrolledUnits = this.getEnrolledUnits()
      //get all the enrolled units for above calendar types and year
      const unitsInActiveBlock = getUnitsByCalendarTypes(
        enrolledUnits,
        allActiveBlockCalendars,
        this.props.year
      )
      //filter first year units that is check against the pattern
      const allUnitsInCoursePatterns = this.props.coursePatternsNoExclusions
        .filter(offering => {
          return (
            allActiveBlockCalendars.indexOf(offering.teachingCalenderType) !=
              -1 && offering.academicYear === this.props.year
          )
        })
        .map(function(offering) {
          return offering.unitCode
        })

      //credit point check for all the units, this should equal Advance standing
      const unitsEnrolledNotInGivenCoursePattern = unitsInActiveBlock.filter(
        ({ unitCd }) => {
          return allUnitsInCoursePatterns.indexOf(unitCd) == -1
        }
      )

      //credit point calculation
      const creditPointsAdvanceStandingFirstYear = unitsEnrolledNotInGivenCoursePattern.reduce(
        function(a, b) {
          return a + b['achievableCreditPoints']
        },
        0
      )

      return (
        this.props.totalAdvanceStandingCredit -
        creditPointsAdvanceStandingFirstYear
      )
    } else {
      return 0
    }
  }
  showBFYAddUnit = () => {
    if (!this.props.isOpen) {
      return null
    }

    if (
      this.props.canAddBeyondFirstYear &&
      this.isFirstYearEnrolledTillGivenBlock()
    ) {
      return (
        <div className="col-xs-6 col-sm-3">
          <div className="block-container">
            <AddUnitHolder
              calendarType={this.props.calendarType}
              onClick={() => this.redirectToSearch()}
              isBFY={true}
            />
          </div>
        </div>
      )
    } else {
      return null
    }
  }
  redirectToSearch = () => {
    this.setState({
      successfulRedirect: true
    })
  }
  addUnit = (unit, disabled) => {
    if (unitDropDatePassed(unit)) {
      this.setState({
        showDropDatePassedConfirmationModal: true,
        unitToAdd: unit,
        dropDateDisabled: disabled
      })
      return
    } else {
      this.props.onAdd(unit)
      return
    }
  }

  handleDropDateCloseModal = () => {
    this.setState({
      showDropDatePassedConfirmationModal: false,
      submitting: false,
      unitToAdd: null
    })
  }

  renderDropDateConfirmationModal = () => {
    return (
      <CustomModal
        className={'drop-date-confirmation-modal'}
        isOpen={this.state.showDropDatePassedConfirmationModal}
        userCanClose={true}
        handleCloseModal={this.handleDropDateCloseModal}
        title="Online withdraw deadline has passed
"
      >
        <div className="question-group">
          <div className="form-items-group">
            The unit you have selected has an early online withdraw deadline
            that has passed. If you proceed, you will be unable to withdraw from
            this unit without college approval.
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6 col-md-6">
            <button
              className="btn btn-lg btn-primary"
              onClick={() => {
                this.setState({ showDropDatePassedConfirmationModal: false })
                this.props.onAdd(this.state.unitToAdd)
              }}
            >
              OK
            </button>
          </div>
          <div className="col-xs-6 col-md-6">
            <button
              className="btn btn-lg btn-primary"
              onClick={this.handleDropDateCloseModal}
            >
              CANCEL
            </button>
          </div>
        </div>
      </CustomModal>
    )
  }

  render() {
    if (this.state.successfulRedirect) {
      return (
        <Switch>
          <Route
            path={getConfiguration('baseUrl') + '/manage/units'}
            render={() => (
              <Redirect
                to={{
                  pathname: getConfiguration('baseUrl') + '/manage/units/add',
                  state: {
                    teachingPeriod: this.props.calendarType,
                    year: this.props.year,
                    canAddBeyondFirstYear: this.props.canAddBeyondFirstYear,
                    advanceStandingCreditRemaining: this.advanceStandingCreditRemaining(),
                    strictPattern: 'false',
                    addModalYear: ''
                  }
                }}
              />
            )}
          />
        </Switch>
      )
    }
    return (
      <CustomModal
        isOpen={this.state.isOpen}
        handleCloseModal={() => this.handleCloseModal()}
        title={`Add unit to ${getCalendarTypeName(this.props.calendarType, this.state.studyPeriods)}`}
        className="modal-xl modal--unit-suggestions"
      >
        <p>
          Below are the units in your course that are available for this
          semester/block.
        </p>
        
        <p>
          Some units require you to meet certain prerequisites or co-requisites for enrolment. If these requirements aren't met, you won't be able to add the unit. Check your{' '}
          <a href="#" target="_blank">
            course structure
          </a>{' '}
          for details or contact your{' '}
          <a href="#" target="_blank">
            Course and Unit Advisor (CUA)
          </a>{' '}
          for assistance
        </p>

        <br />
        <div className="row">
          <div className="col-xs-12">
            <div className="legend-container">
              <div className="legend-item">
                <span className="key key-available" />{' '}
                <span className="key-txt">Available</span>
              </div>
              {/*<div className="legend-item"><span className="key key-prerequisite" /> <span className="key-txt">Prerequisite unit required</span><span className="tooltip"><ActionHelp/></span></div>*/}
              <div className="legend-item">
                <span className="key key-unavailable" />{' '}
                <span className="key-txt">Unit is full</span>
              </div>
              <div className="legend-item">
                <span className="icon-prerequisite">
                  <Link />
                </span>{' '}
                <span className="key-txt">
                  Prerequisite/corequisite units associated
                </span>
              </div>
            </div>
          </div>
        </div>

        {/*------------- START UNIT SUGGESTIONS----------------*/}
        <div className="unit-suggestions">
          <div className="row search-results">
            {this.renderSuggestions()}
            {/* {this.showBFYAddUnit()} */}
          </div>

          {/* /end group of units*/}
        </div>
        {/*------------- /END UNIT SUGGESTIONS----------------*/}
        {this.renderDropDateConfirmationModal()}
      </CustomModal>
    )
  }
}

export default SuggestedUnitsModal
